import Vue from 'vue'
import VueCookie from 'vue-cookie'
import VueLazyload from 'vue-lazyload'
import Vuelidate from 'vuelidate'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store/'
import App from './App'

Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ElementUI)
Vue.use(VueCookie)
Vue.use(VueLazyload, {
loading: '/static/images/load.gif',
})
Vue.use(Vuelidate)

Vue.config.productionTip = false
router.beforeEach(function (to, from, next) {
let wx = navigator.userAgent.toLowerCase()
if (wx.match(/MicroMessenger/i)=="micromessenger") {
store.commit('GET_WXINFO')
if (store.state.wxInfo === null && to.path !== '/authorize') {


var state = to.name + ';' + JSON.stringify(to.query)
window.location.href = 'https://mce.nuohenuode.cn/oauth/yixuezixun?backurl=https%3A%2F%2Fmedinfo.itangyi.com%2Fauthorize?state%3D' + state

} else {
next()
}
} else {
next('/error')
}
})

Vue.filter('getImg', function (value) {
return '/static/images/' + value
})

/* eslint-disable no-new */
new Vue({
el: '#app',
store,
router,
render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js